import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
  Alert
} from '@mui/material';
import { BlockOutlined, ContactSupport } from '@mui/icons-material';
import { useAppContext } from '../context/AppContext';

const AccessDenied: React.FC = () => {
  const { logout } = useAppContext();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh',
        }}
      >
        <Paper
          sx={{
            p: 4,
            textAlign: 'center',
            maxWidth: 500,
            width: '100%',
          }}
        >
          <BlockOutlined
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2,
            }}
          />
          
          <Typography variant="h4" gutterBottom color="error">
            訪問被拒絕
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            您當前沒有訪問任何交易帳戶的權限。請聯繫系統管理員為您分配適當的帳戶權限。
          </Typography>

          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>需要幫助？</strong><br />
              請聯繫您的帳戶管理員或系統支援團隊，以獲取對交易帳戶的訪問權限。
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              startIcon={<ContactSupport />}
              onClick={() => window.open('mailto:support@example.com', '_blank')}
            >
              聯繫支援
            </Button>
            
            <Button
              variant="contained"
              onClick={handleLogout}
            >
              登出
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied;
